import apiClient from './apiClient';

export async function listForecasts(filters = {}) {
  const res = await apiClient.get('/forecasting', { params: filters });
  return res.data.data.items;
}
export async function listSizes() {
  const res = await apiClient.get('/forecasting/sizes');
  return res.data.data.items;
}
export async function getAccuracy() {
  const res = await apiClient.get('/forecasting/accuracy');
  return res.data.data;
}
export async function refreshForecasts() {
  const res = await apiClient.post('/forecasting/refresh');
  return res.data.data;
}
export async function getReorderCard(windowDays) {
  const res = await apiClient.get('/forecasting/reorder', { params: { window: windowDays } });
  return res.data.data;
}
